import { render, staticRenderFns } from "./EventInfo.vue?vue&type=template&id=520c9bf2&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"
import style0 from "./EventInfo.vue?vue&type=style&index=0&id=520c9bf2&prod&scoped=true&lang=scss"
import style1 from "./EventInfo.vue?vue&type=style&index=1&id=520c9bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c9bf2",
  null
  
)

export default component.exports